export const OpenSans = '"Open Sans", sans-serif'

export const Helvetica = 'Helvetica'

export const Manrope = 'Manrope'

export const mediaWidthLaptop = '@media (max-width: 1400px)'
export const mediaWidthMidSize = '@media (max-width: 1600px)'
